import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/destructuring-assignment */
import Dropzone from 'react-dropzone';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import shortid from 'shortid';
import * as loadImage from 'blueimp-load-image';
import styled from 'styled-components';
import { Button, Col, Row } from '@mch-group/uikit-components';
import withLabelsFromAPI from '@dmi-mch/hocs';
import Modal from './Modal';
var ActionBottomMessage = styled.span.withConfig({
  displayName: "ImageUploader__ActionBottomMessage",
  componentId: "sc-14diedx-0"
})(["color:#8a8989;"]);
var ErrorList = styled.ul.withConfig({
  displayName: "ImageUploader__ErrorList",
  componentId: "sc-14diedx-1"
})(["margin-bottom:20px;"]);

var Uploader = /*#__PURE__*/function (_React$Component) {
  _inherits(Uploader, _React$Component);

  var _super = _createSuper(Uploader);

  function Uploader() {
    var _this;

    _classCallCheck(this, Uploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "defaultMessageState", {
      open: false,
      header: '',
      content: ''
    });

    _defineProperty(_assertThisInitialized(_this), "state", {
      file: null,
      ref: null,
      message: _objectSpread({}, _this.defaultMessageState),
      uploadedFile: null,
      uploadInProgress: false
    });

    _defineProperty(_assertThisInitialized(_this), "onFileSelect", function (accepted, rejected) {
      var _this$props = _this.props,
          minWidth = _this$props.minWidth,
          minHeight = _this$props.minHeight;
      var _this$props2 = _this.props,
          maxWidth = _this$props2.maxWidth,
          maxHeight = _this$props2.maxHeight;
      var _this$props3 = _this.props,
          minLengthOnBiggerSide = _this$props3.minLengthOnBiggerSide,
          maxSize = _this$props3.maxSize,
          labelObj = _this$props3.labelObj,
          twelveCols = _this$props3.twelveCols,
          apiLabels = _this$props3.apiLabels;
      var hasDimensionCheck = Boolean(minWidth || minHeight || minLengthOnBiggerSide);

      if (_this.state.file !== null) {
        _this.resetUploader();
      }

      if (accepted.length > 0) {
        // Image dimension check
        if (accepted[0].type.includes('image/') && accepted[0].preview && hasDimensionCheck) {
          var img = new Image();
          img.src = accepted[0].preview;
          img.addEventListener('load', function (loaded) {
            // browser fallback: Edge handles 'target' not 'path'
            var _ref = loaded.path ? loaded.path[0] : loaded.target,
                naturalWidth = _ref.naturalWidth,
                naturalHeight = _ref.naturalHeight;

            if (minLengthOnBiggerSide) {
              if (naturalWidth >= naturalHeight) {
                minWidth = minLengthOnBiggerSide;
              } else {
                minHeight = minLengthOnBiggerSide;
              }
            }

            if (naturalWidth >= minWidth && naturalHeight >= minHeight && naturalWidth <= maxWidth && naturalHeight <= maxHeight) {
              var loadImageOptions = {
                canvas: true
              };
              loadImage.parseMetaData(accepted[0], function (data) {
                if (data.exif && data.exif.get('Orientation')) {
                  loadImageOptions.orientation = data.exif.get('Orientation');
                }

                loadImage(accepted[0], function (canvas) {
                  // Exec selected file callback
                  if (typeof _this.props.onFileSelected === 'function') {
                    _this.props.onFileSelected(canvas.toDataURL(accepted[0].type));
                  }

                  accepted[0].preview = canvas.toDataURL(accepted[0].type); // eslint-disable-line no-param-reassign

                  if (typeof _this.props.uploadToCloudinary === 'function') {
                    _this.props.uploadToCloudinary(accepted);
                  } else {
                    _this.setState({
                      file: accepted
                    }, function () {
                      if (_this.props.uploadOnFileSelect) {
                        if (_this.props.uploadToFuturetek) {
                          _this.uploadFilesToFuturetek();
                        } else {
                          _this.uploadFilesToServer();
                        }
                      }
                    });
                  }
                }, loadImageOptions);
              });
            } else {
              var failedSizeLabels = {
                title: '',
                description: ''
              };

              if ((naturalWidth < minWidth || naturalHeight < minHeight) === true) {
                failedSizeLabels = {
                  title: apiLabels && apiLabels.FieldValidation.ImageTooSmall,
                  description: _this.props.customValidation && _this.props.customValidation.MinImageDimensions ? _this.props.customValidation.MinImageDimensions : apiLabels && apiLabels.FieldValidation.MinImageDimensions
                };
              }

              if (maxWidth && maxHeight && (naturalWidth > maxWidth || naturalHeight > maxHeight) === true) {
                failedSizeLabels = {
                  title: apiLabels && apiLabels.FieldValidation.FileTooBig,
                  description: apiLabels && apiLabels.FieldValidation.maxImageDimensionsMessage
                };
              }

              _this.setState({
                message: {
                  open: true,
                  header: function header() {
                    return /*#__PURE__*/React.createElement("h2", null, labelObj && failedSizeLabels.title || '');
                  },
                  content: function content() {
                    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(ErrorList, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("p", null, failedSizeLabels.description || ''))))), /*#__PURE__*/React.createElement("div", {
                      className: "text-center"
                    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
                      color: "black",
                      onClick: _this.onMessageModalClose
                    }, apiLabels && apiLabels.FieldValidation.MissingFieldsModalButton || ''))));
                  }
                }
              });
            }
          });
        } else {
          _this.setState({
            file: accepted
          }, function () {
            if (_this.props.uploadOnFileSelect) {
              if (_this.props.uploadToFuturetek) {
                _this.uploadFilesToFuturetek();
              } else {
                _this.uploadFilesToServer();
              }
            }
          });
        }
      } // Check rejected files, e.g. file size exceed


      if (rejected.length > 0) {
        var overSizedFiles = [];
        var invalidFormatFiles = [];
        rejected.forEach(function (file) {
          if (file.size > maxSize) {
            overSizedFiles.push(file);
          } else {
            invalidFormatFiles.push(file);
          }
        });

        if (overSizedFiles.length > 0) {
          _this.setState({
            message: {
              open: true,
              header: function header() {
                return /*#__PURE__*/React.createElement("h2", {
                  className: "me-8"
                }, labelObj && labelObj.translate('FileTooBig') || '');
              },
              content: function content() {
                return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
                  md: twelveCols ? 9 : 12
                }, /*#__PURE__*/React.createElement(ErrorList, null, overSizedFiles.map(function (file) {
                  if (file.size > maxSize) {
                    return /*#__PURE__*/React.createElement("li", {
                      key: shortid.generate()
                    }, file.name, " ", /*#__PURE__*/React.createElement("strong", null, "(", Math.round(file.size * 0.000001), "Mb)"));
                  }

                  return null;
                })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
                  width: twelveCols ? 10 : 13,
                  verticalAlign: "middle"
                }, /*#__PURE__*/React.createElement(ActionBottomMessage, null, "".concat(labelObj && labelObj.translate('ImagesMaxFileSize') || ''))), /*#__PURE__*/React.createElement("div", {
                  className: "text-center mt-4"
                }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
                  color: "black",
                  onClick: _this.onMessageModalClose
                }, "OK")))));
              }
            }
          });
        } else {
          _this.setState({
            message: {
              open: true,
              header: function header() {
                return /*#__PURE__*/React.createElement("h2", {
                  className: "pe-8"
                }, labelObj && labelObj.translate('FileFormatNotSupported') || '');
              },
              content: function content() {
                return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
                  width: twelveCols ? 9 : 12
                }, /*#__PURE__*/React.createElement(ErrorList, null, invalidFormatFiles.map(function (file) {
                  return /*#__PURE__*/React.createElement("li", {
                    key: shortid.generate()
                  }, file.name);
                })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
                  md: twelveCols ? 10 : 13,
                  verticalAlign: "middle"
                }, /*#__PURE__*/React.createElement(ActionBottomMessage, null, "".concat(labelObj && labelObj.translate('ImagesFileFormatAllowed') || ''))), /*#__PURE__*/React.createElement("div", {
                  className: "text-center mt-4"
                }, /*#__PURE__*/React.createElement(Col, {
                  md: twelveCols ? 2 : 3
                }, /*#__PURE__*/React.createElement(Button, {
                  color: "black",
                  onClick: _this.onMessageModalClose
                }, "OK")))));
              }
            }
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "uploadFilesToServer", function () {
      _this.setState({
        uploadInProgress: true
      });

      var formData = new FormData();
      var _this$props4 = _this.props,
          api = _this$props4.api,
          apiFormData = _this$props4.apiFormData,
          apiHeaders = _this$props4.apiHeaders,
          tags = _this$props4.tags;
      var headers = {
        'X-Requested-With': 'XMLHttpRequest'
      };

      if (apiHeaders) {
        headers = _objectSpread({
          headers: headers
        }, apiHeaders);
      }

      var uploaders = _this.state.file.map( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
          var req;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  formData.append('file', file);

                  _Object$keys(apiFormData).forEach(function (key) {
                    formData.append(key, apiFormData[key]);
                  }); // for bulk selection in cloudinary console


                  tags && formData.append('tags', tags);
                  _context.next = 5;
                  return axios.post(api, formData, headers);

                case 5:
                  req = _context.sent;

                  if (typeof _this.props.onFileUploadSuccess === 'function') {
                    _this.props.onFileUploadSuccess(req);
                  }

                  return _context.abrupt("return", req);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());

      axios.all(uploaders).then(function (resolve) {
        if (typeof _this.props.onAllFileUploadSuccess === 'function') {
          _this.props.onFileUploadSuccess(resolve);
        }

        _this.setState({
          uploadedFile: resolve,
          uploadInProgress: false
        });
      }).catch(function () {
        _this.setState({
          uploadedFile: null,
          uploadInProgress: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMessageModalClose", function () {
      _this.setState({
        message: _objectSpread({}, _this.defaultMessageState)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resetUploader", function (e) {
      if (typeof _this.props.onFileInputReset === 'function') {
        _this.props.onFileInputReset(_this.props).then(function (response) {
          if (response.ok) {
            _this.setState({
              file: null,
              uploadedFile: null
            });

            typeof _this.props.resetCallback === 'function' && _this.props.resetCallback();
          }
        });
      } else {
        _this.setState({
          file: null,
          uploadedFile: null
        });
      }

      e && e.preventDefault();
    });

    return _this;
  }

  _createClass(Uploader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (_JSON$stringify(this.props) !== _JSON$stringify(nextProps)) {
        return true;
      }

      if (this.state.ref === null && nextState.ref !== null) {
        return true;
      }

      if (this.state.file === null && this.state.ref !== null) {
        return false;
      }

      if (this.state.uploadedFile === null && nextState.uploadedFile && nextState.uploadedFile[0].name !== null) {
        return true;
      }

      if (this.state.file !== null && nextState.file && this.state.file[0].size === nextState.file[0].size) {
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props,
          state = this.state;
      var documentName = state.uploadedFile && state.file && state.file[0].name || props.defaultInputValue || '';
      return /*#__PURE__*/React.createElement("div", {
        className: props.className
      }, /*#__PURE__*/React.createElement(Dropzone, _extends({
        name: props.name,
        id: props.id,
        accept: props.accept,
        maxSize: props.maxSize,
        multiple: props.multiple,
        tags: props.tags,
        ref: function ref(node) {
          state.ref === null && _this2.setState({
            ref: node
          });
        },
        onDrop: this.onFileSelect,
        style: {
          display: 'none'
        }
      }, props.dropzone)), typeof props.children === 'function' && props.children(state.ref, state.file, state.uploadedFile, state.uploadInProgress, this.resetUploader, this.uploadFilesToServer), props.showFileInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        value: documentName // TODO This has been changed to the point of break.
        ,
        icon: documentName && /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            _this2.resetUploader(e);
          }
        }, "X")
      }), /*#__PURE__*/React.createElement(Button, {
        primary: true,
        onClick: function onClick() {
          state.ref.open();
        },
        disabled: state.uploadInProgress,
        loading: state.uploadInProgress,
        type: "button",
        size: "small"
      }, this.props.uploadButtonLabel || 'Upload'))), /*#__PURE__*/React.createElement(Modal, {
        center: true,
        open: state.message.open,
        onClose: this.onMessageModalClose
      }, state.message.header && state.message.header(), state.message.content && state.message.content(), state.message.actions && state.message.actions()));
    }
  }]);

  return Uploader;
}(React.Component);

_defineProperty(Uploader, "propTypes", {
  dropzone: PropTypes.object,
  children: PropTypes.func,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  minLengthOnBiggerSide: PropTypes.number,
  // For sure, one side must be larger than this or equal.
  maxSize: PropTypes.number,
  multiple: PropTypes.bool,
  api: PropTypes.string,
  apiFormData: PropTypes.object,
  tags: PropTypes.string,
  apiHeaders: PropTypes.object,
  uploadOnFileSelect: PropTypes.bool,
  uploadToFuturetek: PropTypes.bool,
  uploadButtonLabel: PropTypes.string,
  defaultInputValue: PropTypes.string,
  onFileInputReset: PropTypes.func,
  onFileSelected: PropTypes.func,
  onFileUploadSuccess: PropTypes.func,
  onAllFileUploadSuccess: PropTypes.func,
  uploadToCloudinary: PropTypes.func,
  resetCallback: PropTypes.func,
  className: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  accept: PropTypes.string,
  showFileInput: PropTypes.bool,
  labelObj: PropTypes.object,
  twelveCols: PropTypes.bool,
  apiLabels: PropTypes.object,
  customValidation: PropTypes.object
});

_defineProperty(Uploader, "defaultProps", {
  minWidth: 0,
  minHeight: 0,
  multiple: false,
  apiFormData: {},
  twelveCols: false
});

export default withLabelsFromAPI(Uploader, ['FieldValidation']);